<template>
  <div class="medical-record-tabs">
    <div class="form-group">
      <label for="">{{ $t("medicalRecord.s5_e1") }}</label>
      <BaseQLEditor :content="medicalRecordData.s5.e1" data-test="qlEditorMedicalRecordS5_e1" @content-changed="setTextForS5E1"></BaseQLEditor>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'ConductSection',
  props: ["medicalRecordData"],
  mounted() {
  },
  methods: {
    setTextForS5E1(value) {
      this.medicalRecordData.s5.e1 = value
    }
  }
}
</script>
